(function () {
  function initOffersDrawer(root) {
    if (!root) return;

    const storageKeyBase = root.getAttribute("data-storage-key") || "offersDrawer";
    const storageKeyOpen = `offersDrawer:${storageKeyBase}:open`;
    const storageKeyDismissed = `offersDrawer:${storageKeyBase}:dismissed`;

    const pill = root.querySelector(".offers-pill");
    const panel = root.querySelector(".offers-panel");
    const closeBtn = root.querySelector(".offers-close");
    const grid = root.querySelector("[data-offers-grid]");
    const countEl = root.querySelector("[data-offers-count]");

    if (!pill || !panel || !grid || !countEl) return;

    function getDismissed() {
      try {
        return JSON.parse(localStorage.getItem(storageKeyDismissed) || "[]");
      } catch (e) {
        return [];
      }
    }

    function setDismissed(arr) {
      try {
        localStorage.setItem(storageKeyDismissed, JSON.stringify(arr));
      } catch (e) {}
    }

    function updateCount() {
      const visibleOffers = grid.querySelectorAll(".offer-card:not([hidden])").length;
      countEl.textContent = String(visibleOffers);
      // If all offers dismissed, hide the whole widget
      if (visibleOffers === 0) {
        root.style.display = "none";
      }
    }

    function applyDismissed() {
      const dismissed = new Set(getDismissed());
      grid.querySelectorAll(".offer-card").forEach((card) => {
        const id = card.getAttribute("data-offer-id");
        if (dismissed.has(id)) card.hidden = true;
      });
      updateCount();
    }

    function openDrawer() {
      root.classList.add("is-open");
      pill.setAttribute("aria-expanded", "true");
      try { localStorage.setItem(storageKeyOpen, "1"); } catch (e) {}
    }

    function closeDrawer() {
      root.classList.remove("is-open");
      pill.setAttribute("aria-expanded", "false");
      try { localStorage.setItem(storageKeyOpen, "0"); } catch (e) {}
    }

    pill.addEventListener("click", function () {
      if (root.classList.contains("is-open")) closeDrawer();
      else openDrawer();
    });

    closeBtn.addEventListener("click", function () {
      closeDrawer();
    });

    // Click outside panel closes (optional but nice)
    document.addEventListener("click", function (e) {
      if (!root.classList.contains("is-open")) return;
      const within = root.contains(e.target);
      if (!within) closeDrawer();
    });

    // Escape key closes
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && root.classList.contains("is-open")) {
        closeDrawer();
      }
    });

    // Dismiss per-offer
    root.addEventListener("click", function (e) {
      const btn = e.target.closest("[data-dismiss-offer]");
      if (!btn) return;

      const card = btn.closest(".offer-card");
      if (!card) return;

      const id = card.getAttribute("data-offer-id");
      if (!id) return;

      card.hidden = true;

      const dismissed = getDismissed();
      if (!dismissed.includes(id)) dismissed.push(id);
      setDismissed(dismissed);
      updateCount();
    });

    // Restore open state
    try {
      const open = localStorage.getItem(storageKeyOpen);
      if (open === "1") openDrawer();
    } catch (e) {}

    applyDismissed();
  }

  function boot() {
    const root = document.getElementById("offersDrawer");
    initOffersDrawer(root);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();